import { gsePricingAnalyticsApi } from 'app/services/api';

import { createNamedActions } from 'utils/namedActionTypesProxy';

// DEV-4979/MC-16: fair-lending surveillance — mirrors analytics.actions.js's wiring (manual try/catch,
// not catchAsyncActionError) so a not-yet-deployed endpoint degrades to a per-page hasError flag
// instead of a global error toast on every Surveillance page load.
export const SURVEILLANCE_ACTION_TYPE = createNamedActions('marginCenter/surveillance', {
  GET_SURVEILLANCE: 'GET_SURVEILLANCE',
  SET_SURVEILLANCE_LOADING: 'SET_SURVEILLANCE_LOADING',
  SET_SURVEILLANCE_ERROR: 'SET_SURVEILLANCE_ERROR',
});

export const getSurveillanceAction = params => async dispatch => {
  dispatch({ type: SURVEILLANCE_ACTION_TYPE.SET_SURVEILLANCE_LOADING, payload: true });

  try {
    const { data } = await gsePricingAnalyticsApi.getSurveillance(params);

    return dispatch({ type: SURVEILLANCE_ACTION_TYPE.GET_SURVEILLANCE, payload: data });
  } catch {
    return dispatch({ type: SURVEILLANCE_ACTION_TYPE.SET_SURVEILLANCE_ERROR });
  }
};
